import { Progress } from "@heroui/react";

export interface StepperIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export function StepperIndicator({ currentStep, totalSteps }: StepperIndicatorProps) {
  return (
    <Progress
      aria-label="Onboarding progress"
      color="primary"
      className="mb-2"
      size="sm"
      value={((currentStep + 1) / totalSteps) * 100}
    />
  );
}
